import React from 'react';

import { Rod } from './styles';

export default function Rodape() {
  return (
    <Rod>
      <h3>Consultoria em Aprendizagem e Comunicações</h3>
      <span>
        Avenida Paulista, 2202 - Cj. 134 - Metrô Consolação - WhatsApp: 11
        97148-6385 Fone: 11 3288-2777
      </span>
      <span>&copy; Copyright Methodus - Todos os direitos reservados.</span>
    </Rod>
  );
}
